import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setAppError } from "../../../../../store/userSlice";
import { axios } from "../../../../../Global";
import reverseDate from "../../../../../utils/reverseDate";

const VrfPaymentConfirm = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();

  useEffect(() => {
    if (!state?.vrfId) navigate("/dashboard/finance/vrf");
  }, []);
  const [loading, setLoading] = useState(false);
  const [paymentRefNo, setPaymentRefNo] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("status", "payment_confirmation");
      formData.append("reference_number", paymentRefNo);
      formData.append("transaction_date", reverseDate(transactionDate));
      formData.append("amount", amount);
      formData.append("file", selectedFile);

      await axios
        .post(
          `/dashboard/finance-visa-vrf/status-update/${state?.vrfId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          dispatch(
            setAppError({
              msg: "Payment Successfully updated.",
              color: "success",
            })
          );
          navigate("/dashboard/finance/vrf");
        })
        .catch((err) => {
          dispatch(setAppError({ msg: err?.message }));
        });
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
    }

    setLoading(false);
  };

  return (
    <div className="w-11/12 lg:w-8/12 md:w-9/12 sm:w-11/12 uppercase mx-auto py-14 bg-white rounded-lg h-fit m-10 border-solid border-2 flex flex-col align-middle justify-center  justify-items-center ">
      <div className=" lg:w-6/12 md:w-8/12 sm:w-10/12 w-10/12 m-auto">
        <h2 className="text-2xl md:text-3xl lg:text-4xl text-center">
          VRF Payment Confirmation
        </h2>
        <p className="text-center">VRF number: {`${state?.vrfNo}`}</p>

        <form
          className="mt-10 flex uppercase flex-col gap-2"
          onSubmit={handleSubmit}
        >
          <div className="mb-3">
            <label
              htmlFor="refno"
              className="my-2 block text-sm font-medium text-gray-700"
            >
              Payment Reference Number
            </label>
            <input
              type="text"
              id="refno"
              placeholder="Enter Payment Reference Number"
              className="border-[1px] uppercase border-border dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
              defaultValue={paymentRefNo}
              onChange={(e) => setPaymentRefNo(e.target.value.toUpperCase())} // Set onChange handler
              required
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="field2"
              className="my-2 block uppercase text-sm font-medium text-gray-700"
            >
              Transaction Date
            </label>
            <input
              type="date"
              defaultValue={transactionDate}
              id="field2"
              name="field2"
              placeholder="Enter Transaction Date"
              className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
              onChange={(e) => setTransactionDate(e.target.value)} // Set onChange handler
              required
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="field3"
              className="my-2 block text-sm font-medium text-gray-700"
            >
              Amount
            </label>
            <input
              type="number"
              value={amount}
              pattern="[0-9]*"
              id="field3"
              name="field3"
              placeholder="Enter Amount"
              className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
              onChange={(e) => setAmount(e.target.value)} // Set onChange handler
              required
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="upload"
              className="my-2 block text-sm font-bold text-gray-700"
            >
              Upload
            </label>
            <input
              type="file"
              id="upload"
              className="file-input uppercase border-border border-[1px] block w-full text-sm text-black
                                        file:mr-4 file:py-2 file:px-4
                                        file:rounded-full file:border-0
                                        file:text-sm file:font-semibold
                                        file:bg-violet-50 file:text-black
                                        file:cursor-pointer"
              onChange={handleFileChange}
              required
            />
          </div>

          <div className="flex gap-3">
            <Link className="flex-1" to="/dashboard/finance/vrf">
              <button className="p-1 w-full rounded-md uppercase  ring-1 ring-black">
                Cancel
              </button>
            </Link>
            <button
              type="submit"
              className={`p-1 flex-1 rounded-md ring-1 uppercase ring-black text-white bg-black flex justify-center items-center gap-2 ${
                loading ? "cursor-not-allowed bg-slate-800" : ""
              }`}
              disabled={loading}
            >
              <p>Submit</p>
              {loading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VrfPaymentConfirm;
